/**
 * Generated by orval v6.29.0 🍺
 * Do not edit manually.
 * Cloudsaver.Invoices.Host.Api
 * OpenAPI spec version: 1.0
 */

/**
 * @nullable
 */
export type BillingInvoiceAdjustmentPlatform = typeof BillingInvoiceAdjustmentPlatform[keyof typeof BillingInvoiceAdjustmentPlatform] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BillingInvoiceAdjustmentPlatform = {
  Aws: 'Aws',
  Azure: 'Azure',
  Gcp: 'Gcp',
} as const;
